import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/database";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import "firebase/compat/functions";
import fbConfig from "./fbConfig";

// firebase.initializeApp(fbConfig);

if (!firebase.apps.length) {
  firebase.initializeApp(fbConfig);
} else {
  firebase.app(); // if already initialized, use that one
}

firebase.firestore();

export default firebase;
